module.exports = __webpack_public_path__ + "static/media/pt.b089a533.png";